const generatePeriodOptions = () => {
  return Array.from({ length: 48 }, (_, i) => {
    const hours = Math.floor(i / 2)
    const minutes = i % 2 === 0 ? '00' : '30'
    const time = `${hours.toString().padStart(2, '0')}:${minutes}`
    return { label: time, value: time }
  })
}

export const periodWithHalfMinutesOptions = generatePeriodOptions()
